import React, { useState, useEffect } from 'react';
import './OrderHistoryPage.css';
import { buildScopedApiUrl, ensureArray, getApiHeaders } from "./config";
import { useWorkspace } from './workspace/WorkspaceContext';

function OrderHistoryForActivePosition() {
  const { workspace } = useWorkspace();

  const [orderHistory, setOrderHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(buildScopedApiUrl('/api/bot/ui/get/getOrderHistoryForAllActivePosition', workspace),
      {
        headers: getApiHeaders()
      })
      .then(response => response.json())
      .then(data => {
        const normalizedHistory = ensureArray(data);
        if (!Array.isArray(data)) {
          console.warn('Unexpected active order history payload shape', workspace, data);
        }
        setOrderHistory(normalizedHistory);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching order history:", error);
        setOrderHistory([]);
        setLoading(false);
      });
  }, [workspace]);

  // Function to format date from timestamp (milliseconds)

  if (loading) return <div className="loading-message">Loading...</div>;

  return (
    <div className="order-history-container">
      <h2 className="page-title">Order History for Active Positions</h2>

      <div className="table-container">
        <table className="order-history-table">
          <thead>
            <tr>
              <th>SigReqId</th>
              <th>Symbol</th>
              <th>Trade Side</th>
              <th>Size</th>             
              <th>Avg Price</th>
              <th>Order Type</th>
              <th>State</th>
              <th>Filled Qty</th>
              <th>Filled Amt</th>
              <th>Total Profits</th>              
              <th>SG Time</th>
              <th>UTime</th>
              <th>Margin Coin</th>
              <th>Leverage</th>
              <th>ID</th>
              <th>Order ID</th>
            </tr>
          </thead>
          <tbody>
            {orderHistory.map(order => (
              <tr key={order.id}>
                <td>{order.signalRequestId}</td>
                <td>{order.symbol}</td>
                <td>{order.tradeSide}</td>
                <td>{order.size}</td>                
                <td>{order.priceAvg}</td>
                <td>{order.orderType}</td>
                <td>{order.state}</td>  
                <td>{order.filledQty}</td>
                <td>{order.filledAmount}</td>
                <td>{order.totalProfits}</td>                              
                <td>{order.convertedSgtTime}</td>
                <td>{order.convertedUTime}</td>   
                <td>{order.marginCoin}</td>
                <td>{order.leverage}</td>       
                <td>{order.id}</td>                
                <td>{order.orderId}</td>      
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default OrderHistoryForActivePosition;
